import React from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import withStyles from "@material-ui/core/styles/withStyles";

const styles = theme => {
  return {
    root: {
      background: theme.palette.primary.main
    }
  };
};

const ContentWrapper = (props) => {
  return (
    <React.Fragment>
      {props.hasHeader ? (
        <div>
          <Paper elevation={0} style={{ height: 56, paddingLeft: 24, display: "flex", alignItems: "center" }} className={props.classes.root} square>
            <Typography variant="h5" style={{ color: "#fff", fontWeight: 500, display: "inline-block" }}>
              {props.title}
            </Typography>
          </Paper>
        </div>
      ) : null}
      <div style={props.hasPadding ? { padding: 25 } : null}>{props.children}</div>
    </React.Fragment>
  );
};

export default withStyles(styles)(ContentWrapper);
